import {registerScriptAttacher} from "../../lib/utils";

registerScriptAttacher<HTMLButtonElement>("wp-block-plaudit-query-loop-reset-link", element => {
	element.addEventListener('click', () => element.dispatchEvent(new Event(element.value || "clear", {bubbles: true, cancelable: true})))
}, (node): node is HTMLButtonElement => node instanceof HTMLButtonElement)
